import { colTableRef } from './consts';

export default function (editor, opts = {}) {
  const bm = editor.BlockManager;
  const style = `
  <style>
  .${opts.pfx} {
    padding: 2px;
  }
  </style>
`;
  if (opts.blocks.indexOf(colTableRef) >= 0) {
    bm.add(colTableRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="32" height="50" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1664 1408"><path d="M512 1248v-192q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V672q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM512 480V288q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V672q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768V288q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V672q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V288q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47H160q-66 0-113-47T0 1248V160Q0 94 47 47T160 0h1344q66 0 113 47t47 113z" fill="#c3cfe9"/></svg>
          <div class="gjs-block-label">${opts.labelTable}</div>`,
      category: opts.labelCMSCategory,
      content: `
        <div class='${opts.pfx} p-3 table-responsive' data-js="data-table" data-gjs-type="data-table">
          <form class="search-form form-inline dc-form-default" data-gjs="search-form" data-gjs-type="search-form" style="justify-content: space-between;">
          <input class="input form-control form-control-sm mb-2 mr-sm-2" type="text" name="search" 
            value="" placeholder="Search"/>
            <div style="flex-grow: 0.96;justify-content: flex-end;display: inline-flex;">
              <button type="submit" class="btn btn-sm btn-primary mb-2 mr-0">Search</button>
              <button type="submit" class="btn btn-sm btn-success mb-2 mr-0" value="export">Download CSV</button>
            </div>
          </form>

          <div data-gjs-type="box" draggable="true" data-highlightable="1" class="box d-none" id="dt-multi-select-container" style="text-align:end;margin-bottom: 1rem;">
            <button data-gjs-type="bootstrap_button" draggable="true" data-highlightable="1" role="button" type="button" class="btn btn-outline-primary btn-md" id="dt-multi-select">Open Bulk Selection Modal</button>
          </div>

          <table class="table table-bordered table-resizable">
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
          </table>
          
           <div data-gjs-type="pagination" draggable="true" data-highlightable="1" data-gjs="pagination" class="pagination" style="text-align:center;">
              <button type="button"  class="btn btn-sm btn-outline-primary first">First</button>
              <button type="button"  class="btn btn-sm btn-outline-primary previous">Previous</button>
              <button type="button" class="btn btn-sm btn-outline-primary next">Next</button>
              <button type="button" class="btn btn-sm btn-outline-primary last">Last</button>
            </div>
        </div>
        ${style}          `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/cms-component-data-table" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelTable
      }?"></i>
          </a>
        </span>
      `,
    });
    bm.add(colTableRef + 'frequently_used', {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="32" height="50" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1664 1408"><path d="M512 1248v-192q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V672q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM512 480V288q0-14-9-23t-23-9H160q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V672q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768V288q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V672q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V288q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47H160q-66 0-113-47T0 1248V160Q0 94 47 47T160 0h1344q66 0 113 47t47 113z" fill="#c3cfe9"/></svg>
          <div class="gjs-block-label">${opts.labelTable}</div>`,
      category: 'Frequently Used',
      attributes: {
        style: 'order: 5',
      },
      content: `
        <div class='${opts.pfx} p-3 table-responsive' data-js="data-table" data-gjs-type="data-table">
          <form class="search-form form-inline dc-form-default" data-gjs="search-form" data-gjs-type="search-form" style="justify-content: space-between;">
          <input class="input form-control form-control-sm mb-2 mr-sm-2" type="text" name="search" 
                   value="" placeholder="Search"/>
          <div style="flex-grow: 0.96;justify-content: flex-end;display: inline-flex;">
            <button type="submit" class="btn btn-sm btn-primary mb-2 mr-0">Search</button>
            <button type="submit" class="btn btn-sm btn-success mb-2 mr-0" value="export">Download CSV</button>
          </div>
          </form>

          <div data-gjs-type="box" draggable="true" data-highlightable="1" class="box d-none" id="dt-multi-select-container" style="text-align:end;margin-bottom: 1rem;">
            <button data-gjs-type="bootstrap_button" draggable="true" data-highlightable="1" role="button" type="button" class="btn btn-outline-primary btn-md" id="dt-multi-select">Open Bulk Selection Modal</button>
          </div>

          <table class="table table-bordered table-resizable">
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
          </table>

           <div data-gjs-type="pagination" draggable="true" data-highlightable="1" data-gjs="pagination" class="pagination" style="text-align:center;">
              <button type="button"  class="btn btn-sm btn-outline-primary first">First</button>
              <button type="button"  class="btn btn-sm btn-outline-primary previous">Previous</button>
              <button type="button" class="btn btn-sm btn-outline-primary next">Next</button>
              <button type="button" class="btn btn-sm btn-outline-primary last">Last</button>
            </div>
        </div>
        ${style}          `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/cms-component-data-table" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelTable
      }?"></i>
          </a>
        </span>
      `,
    });
  }
}
